import { render, staticRenderFns } from "./RadioButtonBigSquare.vue?vue&type=template&id=85d3cc82&scoped=true"
import script from "./RadioButtonBigSquare.vue?vue&type=script&lang=js"
export * from "./RadioButtonBigSquare.vue?vue&type=script&lang=js"
import style0 from "./RadioButtonBigSquare.vue?vue&type=style&index=0&id=85d3cc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d3cc82",
  null
  
)

export default component.exports